<template>
  <l-modal :showing="showing" text="Edit scaling point" icon="edit" color="bg-orange-500" @close="close">
    <div class="w-full text-xs" v-if="editObj.id">
      <div class="w-full flex mb-4">        
        <div class="w-1/2 mr-2">
          <b>Zero point</b><br>
          <l-input placeholder="Zero point" v-model="editObj.zero_point" inputClass="text-2xs" type="number" step="any"  />
        </div>
        <div class="w-1/2">
          <b>Span value</b><br>
          <l-input placeholder="Span value" v-model="editObj.span_value" inputClass="text-2xs" type="number" step="any" />
        </div>
        
      </div>

      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Gas concentration</b><br>
          <l-input placeholder="Gas concentration" v-model="editObj.gas_concentration" inputClass="text-2xs" type="number" step="any" />
        </div>
        <div class="w-1/2">
          <b>Timestamp</b><br>
          <l-input v-model="editObj.timestamp" type="text" placeholder="YYYY-MM-DDTHH:mm:ss" />
        </div>
      </div>
      <l-info-box class="mb-4" :active="message.length > 0">{{message}}</l-info-box>
      <l-l-chart ref="chart"/>
      <div class="flex w-full justify-between">
        <div>
          <l-button type="success" @click="onSave">Save changes</l-button>&nbsp;
          <l-button type="warning" @click="onPreview">Preview changes</l-button>
        </div>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton } from "@/components/forms";
import ScalingService from "@/helpers/services/processing/scaling.service";
import LLChart from "./LLChart"
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox"

export default {
  name: "LLEdit",
  props: [
    "showing",
    "scalingpoint",
    "oc_id"
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LLChart,
    LInfoBox
  },
  data() {
    return {
      message:''
    }
  },
  computed: {
    editObj: function() {
      return Object.assign({}, this.scalingpoint);
    }
  },
  methods: {
    close() {
      //this.editObj = {};
      this.message = '';
      this.$emit("close");
    },
    onSave() {
      this.editObj.oc_id = this.oc_id;
      this.editObj.current_timestamp = this.scalingpoint.timestamp;
      this.$emit("save", this.editObj);
      this.close();
    },
    async preview() {
      this.editObj.oc_id = this.oc_id;
      this.editObj.current_timestamp = this.scalingpoint.timestamp;
      this.$refs.chart.removeSeries();
      this.message = '';
      const res = await ScalingService.preview(this.editObj);
      this.message = res.message;
      var before = { name: 'Imported values', type: 'line', data: res.values.map(v => {return [v.to_epoch, Math.round(v.import_value*1000)/1000]}) };       
      var after = { name: 'Scaled values', type: 'line', data: res.values.map(v => {return [v.to_epoch, Math.round(v.value*1000)/1000]}) };        
      this.$refs.chart.addSeries([before, after]);
    },
    async onPreview() {      
      await Notify.loadData("Scaling data. Please be patient", this.preview);
    }
  }
};
</script>